import React from 'react'
import BaseComponent from './BaseComponent'
import Parallax from 'parallax-js'
import Scroll from 'react-scroll'
import Footer from './Footer'

let scroller = Scroll.scroller
let Element = Scroll.Element

export default class extends BaseComponent {

  constructor(props) {
  	super(props)
  	this.state = { show: false, item: -1, scroll: 0, offset: 0 }
  	this._bind('setContent', 'closeContent', 'onScroll')
    this.season = ""
    document.addEventListener("scroll", this.onScroll)
  }

  componentWillMount() {
    this.season = this.props.season
  }

  componentDidMount() {
  	let sceneLeft = document.getElementById('sceneLeft')
  	let parallaxInstanceLeft = new Parallax(sceneLeft)
  	let sceneRight = document.getElementById('sceneRight')
  	let parallaxInstanceRight = new Parallax(sceneRight)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    document.removeEventListener("scroll", this.onScroll)
  }

  onScroll(e) {
    this.setState({ scroll: document.body.scrollTop || document.documentElement.scrollTop })
  }

  setContent(id, e) {
    e.persist()
    let offset = (e.target.parentElement.offsetHeight - (e.target.offsetTop + e.target.offsetHeight))+52
  	this.setState({ show: true, item: id, offset: offset })
  	setTimeout(() => { this.scrollTo("content") }, 400)
  }

  closeContent() {
  	this.setState({ show: false, offset: 0 })
  }

  scrollTo(el) {
    scroller.scrollTo(el, {
      duration: 1500,
      delay: 100,
      smooth: "easeInOutQuad",
      offset: -40
    })
  }

  render() {
    let data

    if (this.season === "winter") {
      data = this.props.data.winter
    } else {
      data = this.props.data.summer
    }

    return (
      <section className={ "home policy " + this.season }>
	    <div className="bg-left" id="sceneLeft" style={{ marginTop: this.state.scroll/1.5 + "px" }}>
	    	<div data-depth="0.2">{ this.season === "summer" ? <img src="/assets/img/sun-left.png" alt=""/> : <img src="/assets/img/snow-left-1.png" alt=""/> }</div>
	    	<div data-depth="0.4" className="clouds">{ this.season === "summer" ? <img src="/assets/img/clouds-left.png" alt=""/> : <img src="/assets/img/snow-left-2.png" alt=""/> }</div>
	    </div>
	    <div className="bg-right" id="sceneRight" style={{ marginTop: this.state.scroll/1.5 + "px" }}>
	    	<div data-depth="0.2">{ this.season === "summer" ? <img src="/assets/img/sun-right.png" alt=""/> : <img src="/assets/img/snow-right-1.png" alt=""/> }</div>
	    	<div data-depth="0.4" className="clouds">{ this.season === "summer" ? <img src="/assets/img/clouds-right.png" alt=""/> : <img src="/assets/img/snow-right-2.png" alt=""/> }</div>
	    </div>
        <div className="container" dangerouslySetInnerHTML={{ __html: this.props.data.privacy }}></div>
        <Footer lang={ this.props.lang }/>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/PolicyPage.js